export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["COMPUTER"] = 1] = "COMPUTER";
    DeviceType[DeviceType["H5"] = 2] = "H5";
    DeviceType[DeviceType["TV"] = 3] = "TV";
    DeviceType[DeviceType["WATCH"] = 4] = "WATCH";
    DeviceType[DeviceType["OTHER"] = 5] = "OTHER";
    DeviceType[DeviceType["APP"] = 6] = "APP";
    DeviceType[DeviceType["PWA"] = 7] = "PWA";
})(DeviceType || (DeviceType = {}));
//# sourceMappingURL=DeviceType.js.map